export const all_links = {
  all: {
    chrome_extension:
      "https://chromewebstore.google.com/detail/captchasonic-automatic-ca/dkkdakdkffippajmebplgnpmijmnejlh",
    firefox_extension:
      "https://addons.mozilla.org/en-US/firefox/addon/captchasonic/",
    zip: "https://github.com/Captcha-Sonic/CaptchaSonic-Extension/releases/latest",
  },

  bls: {
    chrome_store:
      "https://chromewebstore.google.com/detail/captchasonic-bls-captcha/gpfkfgiphfgpepaefodeppobianfldog",
    firefox_Store:
      "https://addons.mozilla.org/en-US/firefox/addon/captchasonic-solve-bls-captcha/",
    zip_store:
      "https://github.com/Captcha-Sonic/CaptchaSonic-BLS/releases/latest",
  },
  support_mail: "mailto:support@captchasonic.com",
  github: "https://github.com/Captcha-Sonic",
  telegram: "https://t.me/captchasonic",
  discord: "https://discord.captchasonic.com/",

  docs: {
    recaptcha: "https://docs.captchasonic.com/imagetask/recaptcha/",
    PopularCaptcha: "https://docs.captchasonic.com/imagetask/popular/",
    GeeTestCaptcha: "https://docs.captchasonic.com/imagetask/geetest/",
    Awswaf: "https://docs.captchasonic.com/imagetask/aws/",
    Bls: "https://docs.captchasonic.com/imagetask/bls/",
  },
  free_trial: "https://my.captchasonic.com?utm_source=extension&utm_medium=free_trial",
  account: "https://my.captchasonic.com?utm_source=extension&utm_medium=account_link",
  extension: "extension",
  trustpilot: "https://www.trustpilot.com/review/captchasonic.com",
  pricing_api_links: {
    popular: "https://docs.captchasonic.com/",
    bls: "https://docs.captchasonic.com/",
    recaptcha: "https://docs.captchasonic.com/",
    aws: "https://docs.captchasonic.com/",
    geetest3: "https://docs.captchasonic.com/",
    geetest4: "https://docs.captchasonic.com/",
    geetest4_new: "https://docs.captchasonic.com/",
    imagetotext: "https://docs.captchasonic.com/",
    mtcaptcha: "https://docs.captchasonic.com/",
    prosopo: "https://docs.captchasonic.com/",
    tiktok: "https://docs.captchasonic.com/",
    captchafox: "https://docs.captchasonic.com/",
    cloudflareTurnstile: "https://docs.captchasonic.com/",
    cloudflareChallenge: "https://docs.captchasonic.com/",
  },
  status:"https://status.captchasonic.com?utm_source=extension&utm_medium=status_link",
};
